import api from './axiosInstance';

export const getMe = () => api.get('/auth/me');
export const logoutApi = () => api.post('/auth/logout');
